import * as React from 'react';

import * as S from './styled';

type Props = {
  /**
   * Contents to render in popup
   */
  children: React.ReactNode,
  /**
   * Custom trigger
   */
  trigger?: React.ReactNode,
  offset: number,
  tipSize?: number,
  place: string,
  isOpen: boolean,
  className: string,
  preferPlace?: string | null,
  handleOuterAction: { (): void },
  setPopupVisible: { (): void },
};
/**
 * Basic popup
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](ubayd.rahmonzoda@gmail.com)
 */
const Popup = ({
  place,
  isOpen,
  offset,
  tipSize,
  trigger,
  children,
  className,
  preferPlace,
  setPopupVisible,
  handleOuterAction,
}: Props) => (
  <S.StyledPopover
    body={children}
    isOpen={isOpen}
    preferPlace={preferPlace}
    place={place}
    tipSize={tipSize}
    onOuterAction={handleOuterAction}
    offset={offset}
    className={className}
  >
    {trigger ? React.cloneElement(
      trigger,
      {
        isOpen,
        onMouseDown: setPopupVisible,
      },
    ) : (
      <S.Trigger
        isOpen={isOpen}
        onMouseDown={setPopupVisible}
      />
    )}
  </S.StyledPopover>
);

Popup.defaultProps = {
  tipSize: 0.01,
  trigger: null,
  preferPlace: 'below',
};

export default Popup;
